import { lighten } from 'polished'
import styled from 'styled-components'
const defaultBackgroundColor: string = '#03a9f4'

export const ButtonContainer = styled.button<{
  backgroundColor?: string
  size?: string
  fontSize?: string
}>`
  display: inline-block;
  position: relative;
  cursor: pointer;
  width: ${({ size }) => (size ? size : '56px')};
  height: ${({ size }) => (size ? size : '56px')};
  font-size: ${({ fontSize }) => (fontSize ? fontSize : '28px')};
  padding: 0;
  line-height: normal;
  color: #ffffff;
  font-weight: 600;
  font-family: 'Roboto', sans-serif;
  letter-spacing: 0.8px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  vertical-align: middle;
  white-space: nowrap;
  outline: none;
  border: none;
  user-select: none;
  transition: all 0.3s ease-out;
  overflow: hidden;
  margin: auto;
  border-radius: 50%;
  box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.3);
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? backgroundColor : defaultBackgroundColor};
  &:hover {
    text-decoration: none;
    box-shadow: 0 4px 11px 0 rgba(0, 0, 0, 0.375);
    background-color: ${({ backgroundColor }) =>
      backgroundColor
        ? lighten(0.1, backgroundColor)
        : lighten(0.1, defaultBackgroundColor)};
  }
`
